import styled from 'styled-components';
import { Card } from 'antd';
import { COLORS } from '../../constants/colors';

export const PageContainer = styled.div`
  padding: 28px 4px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const ConfigCard = styled(Card)`
  margin-bottom: 20px;
  border-radius: 14px;
  border: 1px solid ${COLORS.border || '#e0e0e0'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;

  .ant-card-head {
    border-bottom: 1px solid ${COLORS.border || '#e0e0e0'};
    min-height: 52px;
    padding: 0 24px;
  }

  .ant-card-body {
    padding: 24px 28px;
  }

  /* Standardize Buttons to 40px */
  .ant-btn {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    font-size: 14px !important;
    border-radius: 8px !important;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  width: 100%;

  &:last-child {
    border-bottom: none;
  }
`;

export const SectionIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${COLORS.$mainTiffany}14;
  color: ${COLORS.$mainTiffany};
  font-size: 14px;
  flex-shrink: 0;
`;

export const FieldRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px 14px 72px;
  border-bottom: 1px solid #f7f7f7;
  transition: background 0.2s ease;

  &:hover {
    background: #fafbfc;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const FieldLabel = styled.span`
  flex: 1;
  font-size: 14px;
  color: ${COLORS.textDark || '#262626'};
  font-weight: 400;
  letter-spacing: 0.01em;
`;

export const FieldControls = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const PhaseTag = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border: 1px solid transparent;
  background: ${props => {
    switch (props.$phase) {
      case 'onsite': return '#e6f7ff';
      case 'deferred': return '#fff7e6';
      case 'both': return '#f0faf4';
      default: return '#f5f5f5';
    }
  }};
  color: ${props => {
    switch (props.$phase) {
      case 'onsite': return '#0070c0';
      case 'deferred': return '#d48806';
      case 'both': return '#389e0d';
      default: return '#999';
    }
  }};
  border-color: ${props => {
    switch (props.$phase) {
      case 'onsite': return '#bae7ff';
      case 'deferred': return '#ffe7ba';
      case 'both': return '#d9f7be';
      default: return '#f0f0f0';
    }
  }};
`;

export const EventSelectorCard = styled(Card)`
  margin-bottom: 28px;
  border-radius: 14px;
  border: 1px solid ${COLORS.border || '#e0e0e0'};
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

  .ant-card-body {
    padding: 24px 28px;
  }

  /* Standardize Select to 40px */
  .ant-select {
    height: 40px !important;

    .ant-select-selector {
      height: 40px !important;
      min-height: 40px !important;
      border-radius: 8px !important;
      font-size: 14px !important;
      display: flex !important;
      align-items: center !important;
    }

    .ant-select-selection-item {
      line-height: 38px !important;
      height: 38px !important;
      font-size: 14px !important;
    }

    .ant-select-selection-placeholder {
      line-height: 38px !important;
      height: 38px !important;
      font-size: 14px !important;
    }
  }

  /* Standardize Buttons to 40px */
  .ant-btn {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    font-size: 14px !important;
    border-radius: 8px !important;
  }
`;

export const SectionCollapseWrapper = styled.div`
  background: #fff;
  border-radius: 14px;
  border: 1px solid ${COLORS.border || '#e0e0e0'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-bottom: 12px;

  .ant-collapse {
    border: none;
    background: transparent;
  }

  .ant-collapse-item {
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }
  }

  .ant-collapse-header {
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;

    .ant-collapse-expand-icon {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 0 0 0 20px !important;
      margin: 0 !important;
      height: auto !important;
    }
  }

  .ant-collapse-content-box {
    padding: 0 !important;
  }
`;
